import { ajaxRetry } from '../../../../lib-api/ajaxRetry';
import { base, createApiURL, ResponseObj } from '../../../../lib-api/services/base';
import {
  PaymentPreInitiationCheckPayload,
  PaymentPreInitiationCheckResponse,
} from '../../../DirectPayments/models/payment';
import { DirectPaymentDetailsModel, PaymentTransferDetailModel } from '../../../models/payments';
import { PaymentProviderDetailsModel, PaymentTransfersResponses } from '../../models/payments';

export const getPaymentDetails = (
  requestId: string
): Promise<ResponseObj<DirectPaymentDetailsModel>> => {
  return ajaxRetry<DirectPaymentDetailsModel>({
    headers: base.headers(),
    method: 'GET',
    url: createApiURL(`/api/v1/payments/requests/${requestId}/data`),
  });
};

export const getProviderPaymentConditions = (
  providerName: string
): Promise<ResponseObj<PaymentProviderDetailsModel>> => {
  return ajaxRetry({
    headers: base.headers(),
    method: 'GET',
    url: createApiURL(`/api/v1/payments/providers/${providerName}/payment-conditions`),
  });
};

export const paymentPreInitiationCheck = (
  paymentRequestId: string,
  payload: PaymentPreInitiationCheckPayload
): Promise<ResponseObj<PaymentPreInitiationCheckResponse | undefined>> => {
  return ajaxRetry({
    data: JSON.stringify(payload),
    headers: base.headers(),
    method: 'POST',
    url: createApiURL(`/api/v1/payments/requests/${paymentRequestId}/preinitiation-check`),
  });
};

export const paymentTransfersDetails = (
  transferId: string
): Promise<ResponseObj<PaymentTransferDetailModel>> => {
  return ajaxRetry<PaymentTransferDetailModel>({
    headers: base.headers(),
    method: 'GET',
    url: createApiURL(`/api/v1/transfer/${transferId}`),
  });
};

export const getTransfers = (paymentRequestId: string) => {
  return ajaxRetry<PaymentTransfersResponses, undefined>({
    headers: base.headers(),
    method: 'GET',
    url: createApiURL(`/api/v1/payments/requests/${paymentRequestId}/transfers`),
  });
};
